module.exports = __webpack_public_path__ + "static/media/Andi-profil3.2b51836c.JPG";